import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Result, Button, Space, Typography } from 'antd';
import { HomeOutlined, FrownOutlined } from '@ant-design/icons';
import './index.css';

const { Title, Text } = Typography;

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="not-found-page">
      <Result
        icon={<FrownOutlined style={{ fontSize: 72, color: '#ff4d4f' }} />}
        title={
          <Title level={1} style={{ color: '#1f1f1f' }}>
            404
          </Title>
        }
        subTitle={
          <Text type="secondary" style={{ fontSize: 18 }}>
            抱歉，您访问的页面不存在
          </Text>
        }
        extra={
          <Space size="large">
            <Button
              type="primary"
              icon={<HomeOutlined />}
              onClick={() => navigate('/')}
              size="large"
            >
              返回首页
            </Button>
            <Button
              type="default"
              onClick={() => navigate(-1)}
              size="large"
            >
              返回上一页
            </Button>
          </Space>
        }
      />
      
      <div className="not-found-content">
        <div className="error-code">404</div>
        <Text type="secondary" className="error-message">
          可能是页面已被删除，或者您输入的地址有误
        </Text>
        
        <div className="suggestions">
          <Title level={4}>建议：</Title>
          <ul>
            <li>检查URL地址是否正确</li>
            <li>返回首页浏览其他内容</li>
            <li>联系管理员反馈问题</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default NotFound;